<template>
    <div>
        <v-snackbar
            v-model="snackbar"
            bottom
            :color="notifyColor"
            :timeout="-1"
            :vertical="isVerticalSnackbar"
        >
            <div>{{ notifyMessage }}</div>
            <div
                v-for="(item, index) in notifyDetails"
                :key="`error-${index}`"
                :class="{ 'mt-4': index === 0 }"
            >
                <span>{{ item }}</span>
            </div>
            <v-btn text @click="onCloseNotifyClick">Close</v-btn>
        </v-snackbar>
        <oops-dialog ref="oopsDialog"></oops-dialog>
    </div>
</template>

<script>
import { isEmpty } from '@/common/helpers';
import OopsDialog from '@/components/Dialogs/OopsDialog';

export default {
    name: 'AppSnackbar',
    components: {
        'oops-dialog': OopsDialog
    },
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            snackbar: false,
            notifyTimeout: 0,
            notifyType: 'info',
            notifyMessage: '',
            notifyDetails: [],
            notifyCheckTimer: null,
            notifyCloseTimer: null,
            isNotifyVisible: false
        };
    },
    computed: {
        notifyColor() {
            if (this.notifyType === 'success') {
                return 'success';
            } else if (this.notifyType === 'error') {
                return 'error';
            } else {
                return 'info';
            }
        },
        isVerticalSnackbar() {
            if (!isEmpty(this.notifyDetails)) {
                return true;
            }
            return false;
        }
    },
    watch: {
        items(newValue) {
            if (newValue && newValue.length > 0) {
                this.startCheckTimer();
            } else {
                this.stopCheckTimer();
            }
        }
    },
    created() {
        if (this.items && this.items.length > 0) {
            this.startCheckTimer();
        }
    },
    methods: {
        startCheckTimer() {
            if (!this.notifyCheckTimer) {
                this.notifyCheckTimer = setInterval(() => {
                    this.checkPendingNotify();
                }, 500);
            }
        },
        stopCheckTimer() {
            if (this.notifyCheckTimer) {
                clearInterval(this.notifyCheckTimer);
                this.notifyCheckTimer = null;
            }
        },
        checkPendingNotify() {
            // will check if any notifications are pending in the queue
            // notifyItem: { type: success/error/info, message: yyy, category: snackbar/dialog, errors: [] }
            if (this.items.length > 0 && !this.isNotifyVisible) {
                // wee need to show the next notification
                this.showNotify(this.items[0]);
            }
        },
        showNotify(item) {
            this.notifyType = item.type;
            this.notifyMessage = item.message;
            this.notifyDetails = [];
            if (item.error instanceof Error || !isEmpty(item.error)) {
                this.notifyDetails = this.parseErrors(item.error);
            }
            this.isNotifyVisible = true;
            this.notifyTimeout = item.type === 'error' ? 10010 : 6010;

            if (item.component === 'dialog' && item.type === 'error') {
                this.$refs.oopsDialog
                    .open(null, null, this.notifyDetails, {
                        confirmActionText: 'Go Home',
                        cancelActionText: 'Go back'
                    })
                    .then(res => {
                        if (res === true) {
                            this.$emit('home-page');
                        }
                        this.closeNotify();
                    });
            } else {
                this.snackbar = true;
                this.notifyCloseTimer = setTimeout(() => {
                    this.closeNotify();
                }, this.notifyTimeout);
            }
        },
        closeNotify() {
            this.isNotifyVisible = false;
            this.snackbar = false;
            this.$emit('notify-close');
        },
        onCloseNotifyClick() {
            // ======= will cancel the close notify timer
            if (this.notifyCloseTimer) {
                clearTimeout(this.notifyCloseTimer);
                this.noifyCloseTimer = null;
                this.closeNotify();
            }
        },
        parseErrors(error) {
            let result = [];
            if (Array.isArray(error)) {
                error.forEach(item => {
                    result.push(this.parseSingleError(item));
                });
            } else {
                result.push(this.parseSingleError(error));
            }

            return result;
        },
        parseSingleError(error) {
            if (
                error &&
                error.response &&
                error.response.data &&
                (error.response.data.message || error.response.data.errors)
            ) {
                return (
                    error.response.data.errors || error.response.data.message
                );
            } else if (error && error.response && error.response.status) {
                return `${error.response.status} - ${error.response.statusText}`;
            } else {
                return error.stack || error.message;
            }
        }
    }
};
</script>
